const namespace = 'doctorProfile';

export const FETCH_DOCTOR_PROFILE = `${namespace}/FETCH_DOCTOR_PROFILE`;
export const SET_DOCTOR_PROFILE_ID = `${namespace}/SET_DOCTOR_PROFILE_ID`;
